/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  suspend(agentId) {
    return axios.patch(`${this.url}/${agentId}/suspend`);
  }

  unsuspend(agentId) {
    return axios.patch(`${this.url}/${agentId}/unsuspend`);
  }
}

export default new Agents();
